import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  EdSupplyChainLimitApi,
  SupplyChainLimit,
  SupplyChainLimitRequest,
  SupplyChainLimitResult,
} from '../tokens/ed-supply-chain-limit.token';

/**
 * REST implementation of the ONE E-D supply-chain-limit API (PRD §1.7 / §3.17 / §2.3, EM-827).
 *
 *   GET  /services/embedded/api/v1/ed/sme/{id}/supply-chain-limit
 *   POST /services/embedded/api/v1/ed/sme/{id}/supply-chain-limit
 *
 * These are the E-D's OWN supply-chain limits (BR-ED-008) — never platform-lender limits. The calling
 * E-D is resolved server-side from the JWT (Rule 22). REST-only (Rules 07/10). Bound to
 * ED_SUPPLY_CHAIN_LIMIT in mock-data.providers.ts. This is the single service used by both the
 * portfolio "Edit Supply-Chain Limit" link and the limit workpage (Rule 17).
 */
@Injectable({ providedIn: 'root' })
export class EdSupplyChainLimitRestService implements EdSupplyChainLimitApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/sme`;

  getLimit(id: number): Observable<SupplyChainLimit> {
    return this.http.get<SupplyChainLimit>(`${this.base}/${id}/supply-chain-limit`);
  }

  requestLimit(id: number, request: SupplyChainLimitRequest): Observable<SupplyChainLimitResult> {
    return this.http.post<SupplyChainLimitResult>(`${this.base}/${id}/supply-chain-limit`, request);
  }
}
